import React, { useState, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

const AddLoisirProductModal = ({ newProduct, setNewProduct, onSubmit }) => {
	const [previewImages, setPreviewImages] = useState([]);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const editorRef = useRef(null);

	const handleImageChange = (e) => {
		const files = Array.from(e.target.files);

		const previews = files.map(file => ({
			url: URL.createObjectURL(file),
			file: file
		}));

		setPreviewImages([...previewImages, ...previews]);
		setSelectedFiles([...selectedFiles, ...files]);
	};

	const handleImageDelete = (index) => {
		if (window.confirm('Êtes-vous sûr de vouloir supprimer cette image ?')) {
			const updatedPreviews = previewImages.filter((_, i) => i !== index);
			const updatedFiles = selectedFiles.filter((_, i) => i !== index);
			setPreviewImages(updatedPreviews);
			setSelectedFiles(updatedFiles);
			URL.revokeObjectURL(previewImages[index].url);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		const productData = {
			...newProduct,
			files: selectedFiles,
			description: editorRef.current ? editorRef.current.getContent() : ''
		};

		try {
			await onSubmit(e, productData);
			previewImages.forEach(preview => URL.revokeObjectURL(preview.url));
			setPreviewImages([]);
			setSelectedFiles([]);
		} catch (error) {
			console.error('Error submitting loisir product:', error);
		}
	};

	return (
		<div className="modal" id="addLoisirProductModal" tabIndex="-1">
			<div className="modal-dialog modal-lg">
				<div className="modal-content">
					<form onSubmit={handleSubmit}>
						<div className="modal-header">
							<h5 className="modal-title">Ajouter un produit loisir</h5>
							<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
						</div>
						<div className="modal-body">
							<div className="mb-4">
								<label className="form-label">Images</label>
								<div className="d-flex flex-wrap gap-3 mb-3">
									{previewImages.map((preview, index) => (
										<div key={index} className="position-relative" style={{ width: '150px', height: '150px' }}>
											<img
												src={preview.url}
												alt={`Preview ${index + 1}`}
												className="img-thumbnail"
												style={{ width: '100%', height: '100%', objectFit: 'cover' }}
											/>
											<button
												type="button"
												className="btn btn-danger btn-sm position-absolute top-0 end-0"
												onClick={() => handleImageDelete(index)}
											>
												×
											</button>
										</div>
									))}
								</div>
								<input
									type="file"
									className="form-control"
									multiple
									accept="image/*"
									onChange={handleImageChange}
								/>
							</div>

							<div className="mb-3">
								<label className="form-label">Titre</label>
								<input
									type="text"
									className="form-control"
									value={newProduct.title}
									onChange={(e) => setNewProduct({ ...newProduct, title: e.target.value })}
									required
								/>
							</div>

							<div className="row">
								<div className="col-md-6">
									<div className="mb-3">
										<label className="form-label">Référence</label>
										<input
											type="text"
											className="form-control"
											value={newProduct.reference}
											onChange={(e) => setNewProduct({ ...newProduct, reference: e.target.value })}
											required
										/>
									</div>
								</div>
								<div className="col-md-6">
									<div className="mb-3">
										<label className="form-label">Quantité disponible</label>
										<input
											type="number"
											className="form-control"
											value={newProduct.quantity || 1}
											onChange={(e) => setNewProduct({ ...newProduct, quantity: parseInt(e.target.value) })}
											required
											min="0"
											placeholder="Stock disponible"
										/>
										<div className="form-text">
											Nombre d'exemplaires disponibles pour la location
										</div>
									</div>
								</div>
							</div>

							<div className="mb-3">
								<label className="form-label">Âge minimum</label>
								<input
									type="text"
									className="form-control"
									placeholder='ex.: 2 ans'
									value={newProduct.minimumAge}
									onChange={(e) => setNewProduct({ ...newProduct, minimumAge: e.target.value })}
								/>
							</div>

							<div className="mb-3">
								<label className="form-label">Description</label>
								<Editor
									onInit={(evt, editor) => editorRef.current = editor}
									init={{
										height: 300,
										menubar: false,
										plugins: ['lists', 'autolink', 'autoresize', 'help', 'wordcount'],
										toolbar: 'bold italic underline | bullist numlist | removeformat help',
										content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
									}}
									onEditorChange={(content) => {
										setNewProduct(prev => ({ ...prev, description: content }));
									}}
								/>
							</div>

							<div className="form-check form-switch mb-3">
								<input
									className="form-check-input"
									type="checkbox"
									checked={newProduct.available}
									onChange={(e) => setNewProduct({ ...newProduct, available: e.target.checked })}
								/>
								<label className="form-check-label">
									{newProduct.available ? 'Disponible' : 'Indisponible'}
								</label>
							</div>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
								Annuler
							</button>
							<button type="submit" className="btn btn-primary">
								Ajouter
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

export default AddLoisirProductModal;